import React from 'react';
import {ReactComponent as Accounts} from '../../assets/svg/icons/accounts.svg';
import {ReactComponent as Address} from '../../assets/svg/icons/address.svg';
import {ReactComponent as ArrowDown} from '../../assets/svg/icons/arrow-down.svg';
import {ReactComponent as ArrowLeft} from '../../assets/svg/icons/arrow-left.svg';
import {ReactComponent as ArrowUp} from '../../assets/svg/icons/arrow-up.svg';
import {ReactComponent as ArrowRight} from '../../assets/svg/icons/arrow-right.svg';
import {ReactComponent as Beaker} from '../../assets/svg/icons/beaker.svg';
import {ReactComponent as Building} from '../../assets/svg/icons/building.svg';
import {ReactComponent as Box} from '../../assets/svg/icons/box.svg';
import {ReactComponent as Calendar} from '../../assets/svg/icons/calendar.svg';
import {ReactComponent as CheckmarkFilled} from '../../assets/svg/icons/checkmark-filled.svg';
import {ReactComponent as Checkmark} from '../../assets/svg/icons/checkmark.svg';
import {ReactComponent as Checkmark2} from '../../assets/svg/icons/checkmark2.svg';
import {ReactComponent as Chemistry} from '../../assets/svg/icons/chemistry.svg';
import {ReactComponent as Consulting} from '../../assets/svg/icons/consulting.svg';
import {ReactComponent as Cross} from '../../assets/svg/icons/cross.svg';
import {ReactComponent as DNA} from '../../assets/svg/icons/dna.svg';
import {ReactComponent as Download} from '../../assets/svg/icons/download.svg';
import {ReactComponent as Drug} from '../../assets/svg/icons/drug.svg';
import {ReactComponent as DryIce} from '../../assets/svg/icons/dry-ice.svg';
import {ReactComponent as Email} from '../../assets/svg/icons/email.svg';
import {ReactComponent as ErrorCircle} from '../../assets/svg/icons/error.svg';
import {ReactComponent as EyeClosed} from '../../assets/svg/icons/eye-closed.svg';
import {ReactComponent as EyeOpen} from '../../assets/svg/icons/eye-open.svg';
import {ReactComponent as Filter} from '../../assets/svg/icons/filter.svg';
import {ReactComponent as Hazardous} from '../../assets/svg/icons/hazardous.svg';
import {ReactComponent as Home} from '../../assets/svg/icons/home.svg';
import {ReactComponent as IcePack} from '../../assets/svg/icons/ice-pack.svg';
import {ReactComponent as Information} from '../../assets/svg/icons/information.svg';
import {ReactComponent as InformationLight} from '../../assets/svg/icons/information-light.svg';
import {ReactComponent as KeystrokeEnter} from '../../assets/svg/icons/keystroke-enter.svg';
import {ReactComponent as Logout} from '../../assets/svg/icons/logout.svg';
import {ReactComponent as MedicalDevice} from '../../assets/svg/icons/medical-device.svg';
import {ReactComponent as MenuArrowDown} from '../../assets/svg/icons/menu-arrow-down.svg';
import {ReactComponent as MenuArrowUp} from '../../assets/svg/icons/menu-arrow-up.svg';
import {ReactComponent as MenuMoreHorizontal} from '../../assets/svg/icons/menu-more-horizontal.svg';
import {ReactComponent as MenuMoreVertical} from '../../assets/svg/icons/menu-more-vertical.svg';
import {ReactComponent as Microscope} from '../../assets/svg/icons/microscope.svg';
import {ReactComponent as Minus} from '../../assets/svg/icons/minus.svg';
import {ReactComponent as NavigationDrawer} from '../../assets/svg/icons/navigation-drawer.svg';
import {ReactComponent as Pencil} from '../../assets/svg/icons/pencil.svg';
import {ReactComponent as Phone} from '../../assets/svg/icons/phone.svg';
import {ReactComponent as Plus} from '../../assets/svg/icons/plus.svg';
import {ReactComponent as Printer} from '../../assets/svg/icons/printer.svg';
import {ReactComponent as Records} from '../../assets/svg/icons/records.svg';
import {ReactComponent as Search} from '../../assets/svg/icons/search.svg';
import {ReactComponent as Sort} from '../../assets/svg/icons/sort.svg';
import {ReactComponent as Success} from '../../assets/svg/icons/success.svg';
import {ReactComponent as TempFull} from '../../assets/svg/icons/temp-full.svg';
import {ReactComponent as TempHalf} from '../../assets/svg/icons/temp-half.svg';
import {ReactComponent as TempOneThird} from '../../assets/svg/icons/temp-one-third.svg';
import {ReactComponent as TempOther} from '../../assets/svg/icons/temp-other.svg';
import {ReactComponent as Trash} from '../../assets/svg/icons/trash.svg';
import {ReactComponent as Truck} from '../../assets/svg/icons/truck.svg';
import {ReactComponent as Upload} from '../../assets/svg/icons/upload.svg';
import {ReactComponent as User} from '../../assets/svg/icons/user.svg';
import {ReactComponent as Users} from '../../assets/svg/icons/users.svg';
import {ReactComponent as Warning} from '../../assets/svg/icons/warning.svg';
import {ReactComponent as AccountCircle} from '../../assets/svg/icons/account-circle.svg';

const icons = {
    Accounts,
    Address,
    ArrowDown,
    ArrowLeft,
    ArrowUp,
    ArrowRight,
    Beaker,
    Building,
    Box,
    Calendar,
    CheckmarkFilled,
    Checkmark,
    Checkmark2,
    Chemistry,
    Consulting,
    Cross,
    DNA,
    Download,
    Drug,
    DryIce,
    Email,
    ErrorCircle,
    EyeClosed,
    EyeOpen,
    Filter,
    Hazardous,
    Home,
    IcePack,
    Information,
    InformationLight,
    KeystrokeEnter,
    Logout,
    MedicalDevice,
    MenuArrowDown,
    MenuArrowUp,
    MenuMoreHorizontal,
    MenuMoreVertical,
    Microscope,
    Minus,
    NavigationDrawer,
    Pencil,
    Phone,
    Plus,
    Printer,
    Records,
    Search,
    Sort,
    Success,
    TempFull,
    TempHalf,
    TempOneThird,
    TempOther,
    Trash,
    Truck,
    Upload,
    User,
    Users,
    Warning,
    AccountCircle
};

const Icon = ( {name, ...props} ) => {
    const Component = icons[name];
    if ( Component ) {
        return <Component {...props} />;
    }

    return null;
}

export default Icon;
